export default "__VITE_ASSET__SoexchSv__"